import React from 'react';
import { Helmet } from 'react-helmet';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import RegisterPrompt from './components/RegisterPrompt';
import TrustSignals from './components/TrustSignals';

const Login = () => {
  return (
    <>
      <Helmet>
        <title>Login - DKS Creator | Build Web Applications</title>
        <meta name="description" content="Sign in to your DKS Creator account to access your web application builder workspace and continue creating amazing applications." />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-br from-background via-muted/20 to-background flex items-center justify-center p-4 md:p-6 lg:p-8">
        <div className="w-full max-w-md">
          <div className="bg-card border border-border rounded-2xl shadow-xl p-6 md:p-8 lg:p-10 space-y-6 md:space-y-7 lg:space-y-8">
            <LoginHeader />
            
            <div className="space-y-6 md:space-y-7 lg:space-y-8">
              <LoginForm />
              <RegisterPrompt />
            </div>
          </div>

          <TrustSignals />

          <div className="text-center mt-6 md:mt-8">
            <p className="text-xs md:text-sm text-muted-foreground">
              &copy; {new Date()?.getFullYear()} DKS Creator. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;